export default {
    name: 'GlobeSmall',
    dimensions: { width: 18, height: 19 },
    content: `
    <g fill="none" stroke="currentColor" stroke-width="2">
        <circle r="8" transform="matrix(1 0 0 -1 9 9.25)" />
        <ellipse rx="3" ry="8" transform="matrix(1 0 0 -1 9 9.25)" />
        <path d="M1 9.25H17" />
    </g>
  `
};
